// Figma: section headings are Roobert 500 at 32/40 (mobile) and 48/60 (desktop)
// with normal tracking; lead copy is 18/28 and 24/32.
export const sectionHeadingClassName =
  '!tracking-normal !text-[32px] !leading-10 sm:!text-5xl sm:!leading-[60px]';

export const sectionLeadClassName =
  '!text-lg !leading-7 sm:!text-2xl sm:!leading-8';
